import { Link } from "react-router-dom";
import usersIcon from "../icons/person.png";
import postsIcon from "../icons/posts.png";
import advertisementsIcon from "../icons/advertisements.png";
import notificationsIcon from "../icons/notifications.png";

export const AdminSidePane = () => {
  return (
    <div className="text-left px-2">
      <div className="mt-1 admin-left-button py-2 ">
        <img  src={postsIcon} />

        <Link to="/admin" >
          Home
        </Link>
      </div>
      <div className="mt-1 admin-left-button py-2 ">
        <img  src={postsIcon} />

        <Link to="/admin/dogs" >
          View All Dogs
        </Link>
      </div>

      <div className="mt-1 admin-left-button py-2">
        <img  src={usersIcon} />

        <Link to="/admin/userss">View All Users</Link>
      </div>

      <div className="mt-1 admin-left-button py-2">
        <img  src={postsIcon} />

        <Link to="/community/posts">View All Posts</Link>
      </div>

      <div className="mt-1 admin-left-button py-2">
        <img  src={advertisementsIcon} />

        <Link to="" >
          View advertissements
        </Link>
      </div>

      <div className="mt-1 admin-left-button py-2">
        <img  src={advertisementsIcon} />

        <Link to="/admin/homepage_images" >
          Edit Gallery Images
        </Link>
      </div>

      <div className="mt-1 admin-left-button py-2">
        <img  src={notificationsIcon} />

        <Link to="" >
          Messages and Notifications
        </Link>
      </div>
      <div className="mt-1 admin-left-button py-2 ">
        <Link to="/home" >
          Go to main site
        </Link>
      </div>
    </div>
  );
};
